module.exports = __webpack_public_path__ + "img/wb.84427931.png";